export default function DevBuddyPrivacy() {
  return (
    <div className="min-h-screen bg-[#FBFAF6] text-[#26313B] p-8 md:p-16 transition-colors duration-300">
      <h1 className="text-4xl font-bold mb-6 text-[#A8720E]">
        Privacy Policy – DevBuddy
      </h1>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        At <strong>Cosmovex</strong>, your privacy is important to us. This
        Privacy Policy explains how we collect, use, store, and protect your
        information when you use <strong>DevBuddy</strong>, our developer tools
        and utilities mobile application.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        📱 Information We Collect
      </h2>

      <ul className="list-disc list-inside text-[#3D4B59] leading-relaxed space-y-2 max-w-3xl">
        <li>
          <strong>App Preferences:</strong> Theme settings, favorite tools, and
          recent tool usage stored locally on your device using SharedPreferences.
          This data never leaves your device.
        </li>
        <li>
          <strong>Usage Data:</strong> App interactions and basic usage events
          collected via Firebase Analytics to improve app performance and
          features. This data is collected in an aggregated and non-personal
          manner.
        </li>
        <li>
          <strong>Crash Reports:</strong> We use Firebase Crashlytics to collect
          crash reports and diagnostic data to help us fix bugs and improve app
          stability. These reports may include device type, OS version, and stack
          traces.
        </li>
        <li>
          <strong>Advertising Identifiers:</strong> Device identifiers and
          ad-related data used for serving and measuring ads through Google
          AdMob.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        🔒 Offline-First Design
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        DevBuddy is designed as an <strong>offline-first</strong> application.
        All developer tools (JSON formatter, Base64 encoder, JWT decoder, regex
        tester, TOTP debugger, encryption tools, and more) run entirely on your
        device. <strong>No user input data is transmitted to any server.</strong>{" "}
        Your code, keys, tokens, and other sensitive data never leave your
        device.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        ☁️ How We Store Your Data
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        All app preferences (theme, favorites, recent tools, usage count) are
        stored locally on your device. We do not store any personal data on
        external servers. Analytics and crash data are stored securely via
        Firebase services with appropriate security measures.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">📊 Analytics</h2>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        DevBuddy uses <strong>Firebase Analytics</strong> to understand how users
        interact with the app. This helps us improve stability, performance, and
        user experience. Analytics data is collected in an aggregated and
        non-personal manner. No tool input or output content is ever collected.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">📢 Advertisements</h2>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        DevBuddy displays ads using <strong>Google AdMob</strong>. AdMob may
        collect device identifiers, approximate location, and interaction data to
        provide and measure ads. We do not sell your personal data, and ad data
        is processed according to Google&apos;s policies.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        👶 Children&apos;s Privacy
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        DevBuddy is not directed at children under the age of 13. We do not
        knowingly collect personal information from children. If you believe a
        child has provided us with personal data, please contact us so we can
        take appropriate action.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        🔄 Changes to This Policy
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        We may update this Privacy Policy from time to time. Any changes will be
        reflected on this page with an updated revision date. We encourage you to
        review this policy periodically.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">🛡️ Contact Us</h2>

      <p className="text-[#3D4B59] leading-relaxed max-w-3xl">
        If you have any questions about this Privacy Policy or data usage, feel
        free to reach out to us at{" "}
        <a
          href="mailto:trionapps@gmail.com"
          className="text-[#0F6BBF] underline hover:text-[#0C5AA3]"
        >
          trionapps@gmail.com
        </a>
        .
      </p>

      <p className="text-[#8A93A2] mt-10">
        Last updated: March 10, 2026
      </p>
    </div>
  );
}
